import { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import axiosWithAuth from "../../utils/axiosWithAuth"
import shortid from "shortid"

import Banner from "../navigation/Banner"
import NavBarOrder from "../navigation/NavBarOrder"
import TicketItem from "../orders/TicketItem"
import ExpoModal from "../navigation/ExpoModal"

function Ticket({ user }) {
  const [ ticketItems, setTicketItems ] = useState([])
  const [ expoModal, setExpoModal ] = useState(false)
  const { order_id, order_number } = useParams()
  const navigate = useNavigate()
  const adminButton = "Back to orders"

  useEffect (() => {
    fetchOrder()    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function fetchOrder() {
    const fetchedOrder = await axiosWithAuth().get(`order/fetch/ticket/${order_id}`)
    setTicketItems(fetchedOrder.data)
  }

  async function expo(o_id) {
    await axiosWithAuth().put(`/order/serve/${o_id}`)
    navigate("/order/admin")
  }

  return (
    <div className="order-dining-page-container" >
      <Banner user={user} />
      <NavBarOrder adminButton={adminButton} />

      <div className="ad-page-content-container">
        <div className="order-dining-content-1">
          <h1>Admin - Order #: {order_number}</h1>
        </div>

        <div className="ticket-items-container">
          {ticketItems.map(item => (
            <TicketItem item={item} key={shortid.generate()} />
          ))}
        </div>

        <div className="ticket-expo" onClick={() => setExpoModal(true)}>
          <div>EXPO</div>
        </div>
      </div>

      {expoModal ?
        <ExpoModal order_id={order_id} expo={expo} onClose={() => setExpoModal(false)} /> 
      : null}
    </div>
  )
}

export default Ticket
